import React, {memo} from "../../../../../__snowpack__/pkg/react.js";
import {Modal} from "../../../../../__snowpack__/pkg/antd.js";
import {useIntl} from "../../../../../__snowpack__/pkg/react-intl.js";
import {useUpdateRoute} from "../../../../lib/useIframe.js";
const GoSettingAlert = memo((props) => {
  const {visible = false} = props;
  const {formatMessage} = useIntl();
  const {updateRouteTab} = useUpdateRoute();
  const handleOk = () => {
    updateRouteTab("accounting");
  };
  const handleCancel = () => {
    window.location.reload();
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Modal, {
    title: formatMessage({id: "tips"}),
    visible,
    okText: formatMessage({id: "SetNow"}),
    cancelText: formatMessage({id: "Refresh"}),
    onOk: handleOk,
    onCancel: handleCancel,
    closable: false
  }, /* @__PURE__ */ React.createElement("p", null, formatMessage({id: "youHaveNotCompletedTheInitial"}))));
});
export default GoSettingAlert;
